import React from 'react';
import { SortableHandle } from 'react-sortable-hoc';

const DragHandle = SortableHandle(({ disabled, tooltip }) => {
  const disabledClass = disabled ? 'disabled' : '';
  const withToolTip = tooltip ? 'with-tooltip' : '';
  return (
    <div className={`sortable-handle ${disabledClass} ${withToolTip}`} title="Drag to reorder" data-tooltip={tooltip}>
      <i className="zolaicon zolaicon-reorder" />
    </div>
  );
});

export default DragHandle;



// WEBPACK FOOTER //
// ./src/components/common/ui/DragHandle.jsx